var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 252.646 252.646",
  style: {
    "enableBackground": "new 0 0 252.646 252.646"
  },
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M225.765,103.53h26.882l-43.5,52l-43.5-52h24.446c-7.301-30.339-34.649-52.957-67.196-52.957 c-27.476,0-52.348,16.268-63.364,41.444L27.468,77.986c16.591-37.914,54.049-62.413,95.429-62.413 C174.813,15.573,217.974,53.767,225.765,103.53z M129.75,237.073c41.38,0,78.838-24.499,95.429-62.413l-32.064-14.031 c-11.017,25.177-35.889,41.444-63.364,41.444c-32.547,0-59.896-22.618-67.196-52.957H87l-43.5-52l-43.5,52h26.882 C34.673,198.88,77.833,237.073,129.75,237.073z"
})));
export default __webpack_public_path__ + "static/media/loading.74f3208f.svg";
export { SvgComponent as ReactComponent };